module.exports = require("web3-shh");